import equipment from '@/utils/kiosks.js'

const state = {
    equipment,
    categories: [{
      slug: 'kiosks',
      name: 'Сенсорные киоски'
    }, {
      slug: 'kiosks-street',
      name: 'Уличные сенсорные киоски'
    }, {
      slug: 'terminals',
      name: 'Терминалы самообслуживания'
    }, {
      slug: 'tables',
      name: 'Сенсорные столы'
    }, {
      slug: 'presentations',
      name: 'Презентационное оборудование'
    }]
}

export default {
    namespaced: true,
    state
}
